import { render, staticRenderFns } from "./AdminEditTask.vue?vue&type=template&id=4d9a9b5e&scoped=true&"
import script from "./AdminEditTask.vue?vue&type=script&lang=js&"
export * from "./AdminEditTask.vue?vue&type=script&lang=js&"
import style0 from "./AdminEditTask.vue?vue&type=style&index=0&id=4d9a9b5e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9a9b5e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d9a9b5e')) {
      api.createRecord('4d9a9b5e', component.options)
    } else {
      api.reload('4d9a9b5e', component.options)
    }
    module.hot.accept("./AdminEditTask.vue?vue&type=template&id=4d9a9b5e&scoped=true&", function () {
      api.rerender('4d9a9b5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/AdminEditTask.vue"
export default component.exports